@for (toast of toastService.toasts; track toast; let i = $index) {
  <app-toast [toast]="toast" [index]="i"></app-toast>
}
